
























































































































































































































































import { Component, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import PageTitle from '@/app/components/Common/PageTitle.vue'
import Loading from '@/app/components/Common/Loading.vue'
import Error409Modal from '@/app/components/Common/Error409Modal.vue'
import DeleteModal from '@/app/components/Common/DeleteModal.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import ErrorInfo from '@/app/components/Common/ErrorInfo.vue'
/* api */
import AreaDetailApi from '@/app/model/api/areaDetailApi'
import AreaEditApi from '@/app/model/api/areaEditApi'
import AreaCreateApi from '@/app/model/api/areaCreateApi'
import AreaDeleteApi from '@/app/model/api/areaDeleteApi'
/* module */
import CommonClass from '@/app/module/common'
import Validator from '@/app/module/validator'

@Component({
  components: {
    CommonHeader,
    PageTitle,
    Loading,
    Error409Modal,
    DeleteModal,
    ErrorModal,
    ErrorInfo
  }
})
export default class AreaCreate extends Vue {
  private areaId: string = ''
  private id: string = ''
  private areaData: any = {}
  private area: string = ''
  private remarks: string = ''
  private timeStamp: number = 0
  private errorMessages: any = ''
  private alertText: string = ''
  private alertTitle: string = ''
  /* 表示非表示 */
  private showLoading: boolean = true
  private editflag: boolean = false
  private showServerErrorModal: boolean = false
  private showConfirmationModal: boolean = false
  private showError409Modal: boolean = false
  private show400ErrorMessage: boolean = false

  created () {
    this.areaId = this.$route.params.area_id
    this.getAreaList()
  }

  private getAreaList () {
    (async () => {
      const routePath = this.$route.path
      if (routePath !== '/master/area/create') {
        this.editflag = true
      }

      if (this.editflag) {
        const result = await AreaDetailApi.getAreaDetail(this.areaId)
        if (result.isOk()) {
          this.areaData = result.getPayload()

          this.id = this.areaData.area_id
          this.area = this.areaData.area_name
          this.remarks = this.areaData.remarks
          this.timeStamp = this.areaData.time_stamp

          this.showLoading = false
        } else {
          const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'text')
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      } else {
        this.showLoading = false
      }
    })()
  }

  private areaSave () {
    if (this.editflag) {
      this.areaEdit()
    } else {
      this.areaCreate()
    }
  }

  private async areaEdit () {
    if (!this.isAreaEdit()) {
      this.alertText = ''
      this.alertTitle = ''
      this.show400ErrorMessage = true
      window.scrollTo({ top: 0, behavior: 'auto' })
      return
    }

    const bodyData = {
      area_name: this.area,
      remarks: this.remarks,
      time_stamp: this.timeStamp
    }

    const result = await AreaEditApi.doAreaEdit(this.$route.params.area_id, bodyData)

    if (result.isOk()) {
      this.$store.commit('alertState/setAlertMessage', { type: 0, text: '地域編集が完了しました。' })
      this.$store.commit('alertState/setAlertFlag', true)
      this.$router.push('/master/area').catch(e => {})
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'PUT', 'text')
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
  }

  private async areaCreate () {
    /* バリデーションチェック */
    if (!this.isAreaEdit()) {
      this.alertText = ''
      this.alertTitle = ''
      this.show400ErrorMessage = true
      window.scrollTo({ top: 0, behavior: 'auto' })
      return
    }

    const bodyData: any = {
      area_name: this.area,
      remarks: this.remarks
    }

    const result = await AreaCreateApi.doAreaCreate(bodyData)

    if (result.isOk()) {
      this.$store.commit('alertState/setAlertMessage', { type: 0, text: '地域登録が完了しました。' })
      this.$store.commit('alertState/setAlertFlag', true)
      this.$router.push('/master/area').catch(e => {})
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'PUT', 'text')
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
  }

  /* バリデーション */
  private isAreaEdit () {
    const areaNameFlag = Validator.validateInputAreaName('areaNameErrorMessage', this.area)
    this.errorMessages = Object.assign({}, this.errorMessages, Validator.getErrorMessage())

    return areaNameFlag
  }

  /* 地域削除 */
  private doAreaDelete () {
    (async () => {
      const result = await AreaDeleteApi.doAreaDelete(this.$route.params.area_id.toString())

      if (result.isOk()) {
        this.$store.commit('alertState/setAlertMessage', { type: 0, text: '地域を削除しました。' })
        this.$store.commit('alertState/setAlertFlag', true)
        this.$router.push('/master/area').catch(e => {})
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'DELETE', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
      this.showConfirmationModal = false
    })()
  }

  private doCancel () {
    this.$router.push('/master/area').catch(e => {})
  }
}
